import { compositionActionsFlat } from "../r-html/dist/store/index.js";
import { cloneDeep, isNumber } from "es-toolkit";
//#region src/engine/tag.ts
var Tag = {
	shared: 1,
	changeOnly: 2,
	following: 4,
	drag: 8,
	dictionarySheet: 16,
	screen: 32
};
function attachActionTag(tag, action) {
	return {
		...cloneDeep(action),
		tags: isNumber(action.tags) && Number.isInteger(action.tags) ? action.tags | tag : tag
	};
}
function attachActionsTag(tag, actions) {
	return actions.map((action) => attachActionTag(tag, action));
}
var createAttachActionsTag = (tag) => (...compositionActions) => function* (state, ctx) {
	yield attachActionsTag(tag, compositionActionsFlat(state, ctx, compositionActions));
};
var attachChangeOnlyTag$ = createAttachActionsTag(Tag.changeOnly);
var attachDictionarySheetTag$ = createAttachActionsTag(Tag.dictionarySheet);
var hasActionTag = (actions, tag) => actions.some(({ tags }) => isNumber(tags) && Number.isInteger(tags) && (tags & tag) !== 0);
//#endregion
export { Tag, attachActionTag, attachActionsTag, attachChangeOnlyTag$, attachDictionarySheetTag$, hasActionTag };
